import { api } from '@/lib/axios-client'
import type {
  ProjectApiResponse,
  ProjectListItem,
  ProjectListItems,
} from '../types/projects-list-types'
import type { ProjectFormData } from '../types/project-popup-types'
export async function getProjectsData(): Promise<ProjectListItem[] | null> {
  const data = await api.get<ProjectListItem[]>(`/Project`)
  if (!data) return null
  return data
}

export async function getProjectsDataByCityId(
  cityId: string,
  pageNumber = 1,
  pageSize = 5,
): Promise<ProjectListItems | null> {
  try {
    const response = await api.get<ProjectListItems>(`/Project/CityId`, {
      params: {
        cityId,
        pageNumber,
        pageSize,
      },
    })
    return response ?? null
  } catch {
    return null
  }
}

export async function addProject(
  project: ProjectFormData,
): Promise<ProjectFormData> {
  project.sizeId = 1
  const response = await api.post<ProjectFormData>('/Project', project)
  return response
}

export async function updateProject(
  project: ProjectFormData,
): Promise<ProjectFormData> {
  const response = await api.put<ProjectFormData>('/Project', project)
  return response
}

export async function getProjectById(
  projectId: string,
): Promise<ProjectApiResponse | null> {
  const project = await api.get<ProjectApiResponse>(
    `/Project/Id?projectId=${projectId}`,
  )
  if (!project) {
    return null
  }
  return project
}

export async function deleteProject(projectId: string): Promise<void> {
  await api.delete<void>(`/Project/Id?projectId=${projectId}`)
}
